import React from "react";
import {
  Box,
  MenuItem,
  Typography,
  Pagination,
  Divider,
  TextField,
  Container,
  Checkbox,
  ListSubheader,
  ListItemText,
  Link,
} from "@mui/material";
import Field from "../components/common/Field/Fi";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import Button from "../components/common/Button/Button";
import ListingCard from "../components/common/ListingCard/ListingCard";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import location from "../assets/svgs/location_list.svg";
import pro_black from "../assets/svgs/pro_black.svg";
import Snackbar from "../components/common/Snackbar/Snackbar";
import ListingShareModal from "../components/common/Modal/ListingShareModal";
import MoreFilterModal from "../components/common/Modal/MoreFilterModal";
import { MobileDatePicker, StaticDatePicker } from "@mui/lab";

import useMediaQuery from "@mui/material/useMediaQuery";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import sort from "../assets/svgs/sort.svg";
import Swipe from "../components/common/GalleryComponent/Swipe";
import BottomFilterModal from "../components/common/Modal/BottomFilterModal";
import BottomSortModal from "../components/common/Modal/BottomSortModal";
import EmbdeListingModal from "../components/common/Modal/EmbdeListingModal";
import CheckMarkSelect from "../components/common/CheckMarkSelect/CheckMarkSelect";
import CheckIcon from "@mui/icons-material/Check";
import SearchField from "../components/common/SearchField/SearchField";
import YearSelect from "../components/common/YearSelect/YearSelect";
import BreadCrumbs from "../components/common/BreadCrumbs/BreadCrumbs";
import ContactSellerModal from "../components/common/Modal/ContactSellerModal";
import ContactSellerLoggedIn from "../components/common/Modal/ContactSellerLoggedIn";
import MakeModel from "../components/common/CheckMarkSelect/MakeModel";
import AuctionListingContainer from "../components/auctionPage/auctionListingContainer";
import ListingPagePagination from "../components/listingPage/ListingPagePagination";
import ListingPageTopBar from "../components/listingPage/ListingPageTopBar";
import LoginModalPLP from "../components/common/Modal/LoginModalPLP";
import AuctionCardImage from "../assets/svgs/auctionCardImgBig.svg";
import BottomLoginModalPLP from "../components/common/Modal/BottomLoginModalPLP";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import AuctionPageTopBar from "../components/auctionPage/auctionPageTopBar";
import BottomFilterModalAuction from "../components/common/Modal/BottomFilterModalAuction";
const filters = [
  { label: "Best Match", val: "bm" },
  { label: "Price (High)", val: "ph" },
  { label: "Price (Low)", val: "pl" },
  { label: "Hours (Most)", val: "hm" },
  { label: "Hours (Least)", val: "hl" },
  { label: "Year (Newest)", val: "yn" },
  { label: "Year (Oldest)", val: "yo" },
];

function AuctionListing({ match }) {
  const [loginModal, setLogInModal] = React.useState(false);
  const handleLogInModal = (bool) => setLogInModal(bool);
  const [loggedIn, setloggedIn] = React.useState(
    match.params.login === "true" ? true : false
  );
  const tabMatch = useMediaQuery("(max-width:900px)");
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [tab, setTab] = React.useState(0);
  const [showSnackbar, setShowSnackbar] = React.useState(false);
  const [showCompare, setShowCompare] = React.useState(false);
  const [comparing, setComparing] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [showSimilar, setShowSimilar] = React.useState(false);
  const [showShareModal, setShowShareModal] = React.useState(false);
  const [showMoreFilterModal, setShowMoreFilterModal] = React.useState(false);
  const [showSortBy, setShowSortBy] = React.useState(false);
  const [showEmbed, setShowEmbed] = React.useState(false);
  const [resetFilters, setResetFilters] = React.useState(false);
  const [showBottomFilterModal, setShowBottomFilterModal] =
    React.useState(false);
  const [sortVal, setSortVal] = React.useState(filters[0].val);
  const [modelList, setModelList] = React.useState([]);
  const [contactSellerLoggedIn, setContactSellerLoggedIn] =
    React.useState(false);
  const [contactSellerModalOpen, setContactSellerModalOpen] =
    React.useState(false);
  function handleContactSellerModal(bool) {
    setContactSellerModalOpen(bool);
  }
  const [RequestVerifiedModal, setRequestVerifiedModal] = React.useState(false);
  function handleRequestVerifiedModal(bool) {
    setRequestVerifiedModal(bool);
  }
  const [page, setPageNo] = React.useState(1);

  const pageNext = () => {
    if (page < 10) setPageNo((old) => old + 1);
  };

  const pagePrev = () => {
    if (page > 1) setPageNo((old) => old - 1);
  };

  const handleSortVal = (e) => {
    setSortVal(e.target.value);
  };

  const toggleDrawerFilter = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowBottomFilterModal(open);
  };

  const toggleDrawerSort = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowSortBy(open);
  };

  const [val, setVal] = React.useState("");

  const handleChange = (event) => {
    setVal(event.target.value);
  };

  const handleSnackbarOpen = (e) => {
    setShowSnackbar(true);
    setComparing(true);
    if (!e || e.target.checked) setCount((oldCount) => oldCount + 1);
    else {
      if (count - 1 === 0) setComparing(false);
      setCount((oldCount) => oldCount - 1);
    }
  };

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShowSnackbar(false);
  };

  React.useEffect(() => {
    if (showCompare) {
      // scroll to top
      window.scrollTo(0, 0);
    }
  }, [showCompare]);

  const handleCompare = () => {
    setShowCompare(true);
    setShowSnackbar(false);
    setComparing(false);
    setCount(0);
  };

  const handleResetFilters = () => {
    setResetFilters(true);
    setVal("pro");
    setModelList([]);
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: { xs: "8px", sm: "0px" },
        boxShadow: {
          xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          sm: "none",
        },
      }}
    >
      <Box
        sx={{
          display: { xs: "none", sm: "block" },
          height: "1px",
          width: "100%",
          backgroundColor: "#D6D6D6",
        }}
      ></Box>

      <AuctionPageTopBar
        handleChange={handleChange}
        resetFilters={resetFilters}
        setShowMoreFilterModal={setShowMoreFilterModal}
        toggleDrawerFilter={toggleDrawerFilter}
        toggleDrawerSort={toggleDrawerSort}
        val={val}
      />
      {!mobMatch && (
        <>
          <Box
            sx={{
              height: "1px",
              width: "100%",
              backgroundColor: "#D6D6D6",
            }}
          ></Box>
          <Container
            disableGutters={true}
            sx={{
              display: "flex",
              width: "100%",
              marginTop: "8px",
              marginRight: "24px",
              paddingRight: { sm: "24px", md: "0" },
              justifyContent: "end",
            }}
          >
            <Typography
              variant="caption"
              fontWeight="400"
              fontSize="12px"
              lineHeight="16px"
              color="primary.main"
              sx={{
                "&:hover": {
                  cursor: "pointer",
                  textDecoration: "underline",
                },
              }}
              onClick={handleResetFilters}
            >
              Reset filters
            </Typography>
          </Container>
        </>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginX: "10.5%",
          marginBottom: "48px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            columnGap: "24px",
          }}
        >
          <Box>
            {!mobMatch && (showCompare || showSimilar) && (
              <Box sx={{ marginLeft: tabMatch && "24px" }}>
                {showCompare ? (
                  <BreadCrumbs
                    breadCrumbList={["Auction Calender", "Compare Listings"]}
                  />
                ) : (
                  <BreadCrumbs
                    breadCrumbList={["All Machinery", "Similar Listings"]}
                  />
                )}
              </Box>
            )}
            {mobMatch ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "4px",
                  marginLeft: "16px",
                  marginBottom: "16px",
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontFamily="Inter"
                  fontWeight="600"
                  fontSize="16px"
                  lineHeight="24px"
                  color="#000000"
                >
                  {tabMatch
                    ? showCompare
                      ? "Your compared listings"
                      : showSimilar
                      ? "Similar listings"
                      : "Auction Calender"
                    : "Auction Calender"}
                </Typography>
                <Typography
                  variant="body2"
                  fontFamily="Inter"
                  fontWeight="400"
                  fontSize="14px"
                  lineHeight="20px"
                  color="#616161"
                >
                  {tabMatch
                    ? showCompare
                      ? "2 results"
                      : showSimilar
                      ? "4 results matches your selected listing"
                      : "1,208 results"
                    : "1,208 results"}
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: { xs: "auto", md: "876px" },
                  margin: "auto",
                  marginX: { xs: "5%", sm: "24px", md: "auto" },
                  marginBottom: "48px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "8px",
                  }}
                >
                  <Typography
                    variant="headline2"
                    fontFamily="Inter"
                    fontWeight="700"
                    fontSize="32px"
                    lineHeight="36px"
                    color="text.primary"
                  >
                    {showCompare
                      ? "Your compared listings"
                      : showSimilar
                      ? "Similar Listings"
                      : "Auction Calender"}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "4px",
                  }}
                >
                  <Typography
                    variant="body2"
                    fontWeight="400"
                    fontSize="14px"
                    lineHeight="20px"
                    color="#616161"
                  >
                    {showCompare ? "4" : "1,208"} results
                    {showSimilar && " matches your selected listing"}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "16px",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "8px",
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="400"
                      fontSize="16px"
                      lineHeight="24px"
                      color="text.primary"
                    >
                      Show only
                    </Typography>
                    <Button
                      variant="outlined"
                      bgColor={tab === 0 ? "#255CCE1A" : "#F5F5F5"}
                      outColor={tab === 0 ? "#255CCE" : ""}
                      onClick={() => setTab(0)}
                      sx={{
                        maxWidth: "130px",
                        minWidth: "117px",
                        height: "36px",
                        padding: "6px 8px",
                        border: tab === 1 && "none",
                        "&:hover": {
                          border: tab === 1 && "none",
                        },
                      }}
                      size="lg"
                      txColor={tab === 0 ? "primary.main" : "text.primary"}
                      typoVariant="body1"
                      typoSize={"16px"}
                      fontWeight="400"
                    >
                      Online Auction
                    </Button>
                    <Button
                      variant="outlined"
                      bgColor={tab === 1 ? "#255CCE1A" : "#F5F5F5"}
                      outColor={tab === 1 ? "#255CCE" : ""}
                      onClick={() => setTab(1)}
                      sx={{
                        minWidth: "97px",
                        height: "36px",
                        padding: "6px 8px",
                        border: tab === 0 && "none",
                        "&:hover": {
                          border: tab === 0 && "none",
                        },
                      }}
                      size="lg"
                      txColor={tab === 1 ? "primary.main" : "text.primary"}
                      typoVariant="body1"
                      fontWeight="400"
                    >
                      On Site Auction
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "8px",
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="400"
                      fontSize="16px"
                      lineHeight="24px"
                      color="text.primary"
                    >
                      Sort by
                    </Typography>
                    <Field
                      value={sortVal}
                      handleChange={handleSortVal}
                      label=""
                      height="36px"
                      star={false}
                      sx={{ width: "150px" }}
                      select={true}
                      filled={false}
                    >
                      {filters.map((f) => (
                        <MenuItem key={f.val} value={f.val}>
                          {f.label}
                        </MenuItem>
                      ))}
                    </Field>
                  </Box>
                </Box>
              </Box>
            )}
            <AuctionListingContainer
              comparing={comparing}
              count={count}
              handleContactSellerModal={handleContactSellerModal}
              handleSnackbarOpen={handleSnackbarOpen}
              loggedIn={loggedIn}
              setContactSellerLoggedIn={setContactSellerLoggedIn}
              setShowCompare={setShowCompare}
              setShowShareModal={setShowShareModal}
              setShowSimilar={setShowSimilar}
              showCompare={showCompare}
              handleLogInModal={handleLogInModal}
            />
            <ListingPagePagination
              page={page}
              pageNext={pageNext}
              pagePrev={pagePrev}
            />
            <Snackbar
              open={showSnackbar}
              handleClose={handleSnackbarClose}
              message={
                count >= 2
                  ? `Compare ${count} machinery`
                  : "Select 1 more machinery to compare."
              }
              button={count >= 2 ? 1 : 0}
              btn1Label="Compare now"
              btn1OnClick={handleCompare}
            />
          </Box>
          <Box
            sx={{
              marginTop: showCompare || showSimilar ? "202px" : "170px",
              display: { xs: "none", xl: "block" },
            }}
          >
            <Box
              sx={{
                width: "300px",
                height: "240px",
                backgroundColor: "#EBEBEB",
              }}
            ></Box>
            <Box
              sx={{
                marginTop: "24px",
                minWidth: "300px",
              }}
            >
              <Typography
                variant="subtitle2"
                fontWeight="600"
                fontSize="14px"
                lineHeight="20px"
                color="text.primary"
                sx={{ marginBottom: "8px" }}
              >
                Popular searches
              </Typography>
              <SearchItem text="Bobcat for sale in uae" />
              <SearchItem text="Wheel loader for sale in uae" />
              <SearchItem text="Excavator for sale in uae" />
              <SearchItem text="Cranes for sale in uae" />
              <SearchItem text="Telehandler for sale in uae" />
              <SearchItem text="Skid steer for sale in uae" />
              <SearchItem text="Dozer for sale in uae" />
              <SearchItem text="Tractor head for sale" />
            </Box>
            <Box
              sx={{
                margin: "16px 0",
                height: "1px",
                width: "268px",
                backgroundColor: "#D6D6D6",
              }}
            ></Box>
            <Box
              sx={{
                marginTop: "24px",
                minWidth: "300px",
              }}
            >
              <Typography
                variant="subtitle2"
                fontWeight="600"
                fontSize="14px"
                lineHeight="20px"
                color="text.primary"
                sx={{ marginBottom: "8px" }}
              >
                Popular searches for Wheel Excavator
              </Typography>
              <SearchItem text="Bobcat for sale in uae" />
              <SearchItem text="Wheel loader for sale in uae" />
              <SearchItem text="Excavator for sale in uae" />
              <SearchItem text="Cranes for sale in uae" />
              <SearchItem text="Telehandler for sale in uae" />
              <SearchItem text="Skid steer for sale in uae" />
              <SearchItem text="Dozer for sale in uae" />
              <SearchItem text="Tractor head for sale" />
            </Box>
            <Box
              sx={{
                width: "300px",
                height: "600px",
                backgroundColor: "#EBEBEB",
                marginTop: "24px",
              }}
            ></Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          margin: { xs: "32px 16px", md: "76px 14.28% 48px" },
          paddingBottom: { xs: "32px", sm: "32px" },
          marginBottom: { xs: "16px", sm: "32px", md: "auto" },
        }}
      >
        <Typography
          variant="body2"
          fontFamily="Roboto"
          fontWeight="400"
          fontSize="14px"
          lineHeight="20px"
          color="#616161"
          textAlign="justify"
        >
          At Machinery Planet, we have both new and used Crawler Excavators
          listed on our website for sale, for rent and for auction depending on
          what you want;, we are the number one platform for sourcing for
          Crawler Excavators dealers in Dubai, UAE. You can always count on us
          to link you up with dealers that sell quality and affordable Crawler
          Excavators that promises good value for your money. We have all kinds
          of Crawler Excavators such as three-wheel counterbalance Crawler
          Excavators, telescopic handler Crawler Excavators, pedestrian pallet
          trucks, order picker Crawler Excavators, and side loader Crawler
          Excavators among others listed on our platform. So whatever type of
          Crawler Excavators you are looking for, we have got you covered at
          Machinery Planet.
          <br /> <br />
          You can always rely on our expertise whenever you call on us to rent
          any kind of Crawler Excavators for your short term or long term use.
          All you need to do is to get in touch with us and we will work with
          you to get the right Crawler Excavators of your choice.
          <br />
          <br />
          Our rental fees are affordable and competitive enough compared with
          what you will get elsewhere. Machinery Planet is your home of a
          variety of Crawler Excavators that will suit your needs, you cannot go
          wrong with the broad options listed on Machinery Planet. We will help
          you to easily source for the right Crawler Excavators that best suits
          your specification and requirements as we understand the fact that
          delivering quality to our customers is the only way we can earn their
          trust. When we earn the trust of our customer, they can always refer
          other potential customers to us and it is based on this knowledge we
          operate at Machinery Planet.
        </Typography>
      </Box>
      <ListingShareModal
        open={showShareModal}
        setOpen={setShowShareModal}
        setEmbedOpen={setShowEmbed}
      />
      <MoreFilterModal
        resetFilter={resetFilters}
        open={showMoreFilterModal}
        setOpen={setShowMoreFilterModal}
        setReset={setResetFilters}
      />
      <BottomFilterModalAuction
        open={showBottomFilterModal}
        toggleDrawer={toggleDrawerFilter}
      />
      <BottomSortModal open={showSortBy} toggleDrawer={toggleDrawerSort} />
      <EmbdeListingModal open={showEmbed} setOpen={setShowEmbed} />
      {!mobMatch && (
        <LoginModalPLP
          open={loginModal}
          setOpen={handleLogInModal}
          children={<ProductDetails />}
        />
      )}
      {mobMatch && (
        <BottomLoginModalPLP
          open={loginModal}
          toggleDrawer={handleLogInModal}
        />
      )}
      {mobMatch ? null : (
        <>
          <ContactSellerModal
            open={contactSellerModalOpen}
            setOpen={setContactSellerModalOpen}
            verifiedModal={handleRequestVerifiedModal}
          />
          <ContactSellerLoggedIn
            open={contactSellerLoggedIn}
            setOpen={setContactSellerLoggedIn}
          />
        </>
      )}
    </Box>
  );
}

function SearchItem({ text }) {
  return (
    <Link
      sx={{
        color: "text.primary",
        textDecoration: "none",
        "&:hover": { cursor: "pointer" },
      }}
    >
      <Typography
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        color="#616161"
        sx={{
          "&:hover": {
            color: "primary.main",
          },
        }}
      >
        {text}
      </Typography>
    </Link>
  );
}

const ProductDetails = () => {
  return (
    <Box sx={{ width: "336px", marginTop: "32px" }}>
      <img
        src={AuctionCardImage}
        alt="machine"
        style={{ borderRadius: "8px", width: "100%", height: "207px" }}
      />
      <Box sx={{ marginTop: "24px" }}>
        <Typography
          variant="subtitle1"
          component="div"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "600",
          }}
        >
          January Breda: Agricultural And Construction
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexFlow: "column",
            rowGap: "8px",
            marginTop: "24px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <EventAvailableOutlinedIcon
              sx={{
                color: "text.secondary",
                width: "14px",
                height: "14px",
                marginRight: "4px",
              }}
            />
            <Typography
              color="text.primary"
              fontWeight="400"
              sx={{
                variant: { xs: "caption", sm: "body2" },
                fontSize: { xs: "12px", sm: "14px" },
                lineHeight: { xs: "16px", sm: "20px" },
              }}
            >
              21 Jan 2022 - 26 Jan 2022
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
              src={location}
              style={{
                objectFit: "contain",
                width: "12px",
                height: "12px",
                marginRight: "4px",
              }}
              alt="location"
            />
            <Typography
              color="text.primary"
              fontWeight="400"
              sx={{
                variant: { xs: "caption", sm: "body2" },
                fontSize: { xs: "12px", sm: "14px" },
                lineHeight: { xs: "16px", sm: "20px" },
              }}
            >
              United Arab Emirates
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AuctionListing;
